import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=42970b57&scoped=true"
import script from "./QuotationList.vue?vue&type=script&lang=js"
export * from "./QuotationList.vue?vue&type=script&lang=js"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=42970b57&prod&lang=scss"
import style1 from "./QuotationList.vue?vue&type=style&index=1&id=42970b57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42970b57",
  null
  
)

export default component.exports